import { useMemo, useState } from 'react';
import {
  startOfMonth,
  startOfWeek,
  addDays,
  addMonths,
  subMonths,
  isSameMonth,
} from 'date-fns';

export const useCalendar = () => {
  const [currentDate, setCurrentDate] = useState(new Date());

  const goToNextMonth = () => {
    setCurrentDate((prev) => addMonths(prev, 1));
  };

  const goToPrevMonth = () => {
    setCurrentDate((prev) => subMonths(prev, 1));
  };

  const daysInCalendar = useMemo(() => {
    const start = startOfWeek(startOfMonth(currentDate), { weekStartsOn: 0 }); 
    const days = [];

    for (let i = 0; i < 42; i++) { 
      const day = addDays(start, i);
      days.push({
        date: day,
        isCurrentMonth: isSameMonth(day, currentDate),
      });
    }

    return days;
  }, [currentDate]);

  return {
    currentDate,
    goToNextMonth,
    goToPrevMonth,
    daysInCalendar,
  };
}
